// extracted by mini-css-extract-plugin
export default {"background":"Preview_background__HmEEv","playing":"Preview_playing__iR9jW","play":"Preview_play__7NIdN"};